"use strict";

exports.__esModule = true;
exports.DevicePropertyWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _DevicePropertyElement = require("./DevicePropertyElement");
var _DevicePropertyFields = require("./DevicePropertyFields");
var _DevicePropertyHeader = require("./DevicePropertyHeader");
var _DevicePropertyThumbnail = require("./DevicePropertyThumbnail");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DevicePropertyWidget = exports.DevicePropertyWidget = {
  name: "DeviceProperty",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "DevicePropertyWidget.label",
    defaultMessage: "Device Property"
  }),
  icon: "property",
  group: _widgetGroups.DEVICE_INFORMATION_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "DeviceProperty",
      props: Object.assign({
        width: 128,
        height: 64,
        propertyName: "name"
      }, props),
      children: []
    };
  },
  showInPalette: true,
  isParent: false,
  requiresContexts: ["device"],
  suppliesContexts: [],
  optionalProps: ["fontFamily", "fontSize", "fontWeight", "fontStyle", "textDecoration", "textAlignment", "color", "backgroundColor", "backgroundColorSource"],
  requiresProps: ["x", "y", "width", "height", "propertyName"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 128,
      min: 32,
      max: 3840
    },
    height: {
      "default": 64,
      min: 32,
      max: 2160
    }
  },
  components: {
    Header: _DevicePropertyHeader.DevicePropertyHeader,
    Element: _DevicePropertyElement.DevicePropertyElement,
    Fields: _DevicePropertyFields.DevicePropertyFields,
    Thumbnail: _DevicePropertyThumbnail.DevicePropertyThumbnail
  }
};